import clsx from 'clsx';

const InfoIcon = ({ className }: { className?: string }) => (
  <svg
    className={clsx(className, 'fill-current')}
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16 9.75C14.85 9.75 14 8.925 14 7.875C14 6.825 14.85 6 16 6C17.15 6 18 6.775 18 7.8C18 8.9 17.175 9.75 16 9.75ZM14.425 25.3V11.95H17.55V25.3H14.425Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 30C23.732 30 30 23.732 30 16C30 8.26801 23.732 2 16 2C8.26801 2 2 8.26801 2 16C2 23.732 8.26801 30 16 30ZM16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
    />
  </svg>
);
export default InfoIcon;
